/** Local nav for Users section — All users + Roles only (no Invitations / Teams). */
export const USERS_LOCAL_NAV = [
  { href: "/users/all", label: "All users" },
  { href: "/users/roles", label: "Roles & Permissions" },
] as const;

export function usersNavActive(
  href: (typeof USERS_LOCAL_NAV)[number]["href"],
  pathname: string,
): boolean {
  // Roles (including /users/roles/:id) must win over a loose /users prefix.
  if (href === "/users/roles") {
    return pathname === "/users/roles" || pathname.startsWith("/users/roles/");
  }
  return pathname === "/users/all" || pathname.startsWith("/users/all?");
}

export type UserRowMenuAction =
  | "resend"
  | "revoke"
  | "suspend"
  | "reactivate"
  | "password_reset"
  | "remove"
  | "edit";

/** Allowed overflow-menu actions for a directory row by status. */
export function allowedUserRowActions(status: string): UserRowMenuAction[] {
  const s = status.toUpperCase();
  if (s === "INVITED") return ["edit", "resend", "revoke", "remove"];
  if (s === "ACTIVE") return ["edit", "password_reset", "suspend", "remove"];
  if (s === "SUSPENDED") return ["edit", "reactivate", "remove"];
  return [];
}

export function validateEditUserForm(input: {
  firstName: string;
  lastName: string;
  roleId: string;
}): string | null {
  if (!input.firstName.trim()) return "First name is required.";
  if (!input.lastName.trim()) return "Last name is required.";
  if (!input.roleId.trim()) return "Select a role.";
  return null;
}

export function validateAddUserForm(input: {
  firstName: string;
  lastName: string;
  email: string;
  roleId: string;
}): string | null {
  if (!input.firstName.trim()) return "First name is required.";
  if (!input.lastName.trim()) return "Last name is required.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.email.trim())) {
    return "Enter a valid email address.";
  }
  if (!input.roleId.trim()) return "Select a role.";
  return null;
}

export function validateAddRoleForm(input: { name: string }): string | null {
  if (!input.name.trim()) return "Role name is required.";
  if (input.name.trim().length < 2) return "Role name is too short.";
  return null;
}
